<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" id="contentIncreasePettyCash">
    <div class="flex items-center py-8 justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl z-50 w-[96vw] max-w-3xl">
        <div class="flex justify-between items-center px-6 py-5 bg-green-50 border-b border-green-100">
          <div>
            <h2 class="text-xl font-bold text-green-700 uppercase">Aumentar balance de caja chica</h2>
            <p class="text-sm text-green-600 mt-1">
              Usa esta opción cuando ingreses más dinero a la caja chica.
            </p>
          </div>
          <button
            @click="isActive"
            class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <svg class="w-5 h-5">
              <use href="../../assets/svg/icon.svg#cancel" />
            </svg>
          </button>
        </div>

        <form class="w-full space-y-6 px-6 py-6" @submit.prevent>
          <div class="grid gap-6">
            <label class="block">
              <span class="block mb-2 text-sm font-medium text-gray-800">
                Monto a aumentar <span class="text-red-300">*</span>
              </span>
              <input
                type="number"
                min="0"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-green-500"
                v-model="dataForm.amount"
                placeholder="0.00"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span class="block mb-2 text-sm font-medium text-gray-800">
                Concepto del aumento
              </span>
              <textarea
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 resize-none w-full border-2 focus:border-green-500"
                v-model="dataForm.concept"
                rows="3"
                maxlength="255"
              ></textarea>
            </label>
          </div>

          <div class="flex justify-end">
            <button
              class="bg-green-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-green-600 active:scale-95 flex items-center"
              @click="increaseBalance"
              :disabled="spinner"
            >
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                Aumentando balance
              </div>
              <span v-else>Aumentar balance</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import axios from "@/api";
import { confirmationOfRecord, errorActions } from "@/alerts";
import { observeElement } from "@/observer";
import { idLocalStore, idLocalTurn, idLocalUser } from "@/publicjs/localStorage";

export default {
  name: "IncreasePettyCashBalance",
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const spinner = ref(false);
    const dataForm = ref({
      idStore: 0,
      idUser: 0,
      idTurn: 0,
      amount: "",
      concept: "",
    });

    const isActive = () => {
      props.activeModal(true);
    };

    const increaseBalance = async () => {
      if (
        dataForm.value.amount === "" ||
        dataForm.value.amount === null ||
        parseFloat(dataForm.value.amount) <= 0
      ) {
        errorActions("Ingresa un monto mayor a 0 para aumentar el balance");
        return;
      }

      spinner.value = true;
      const response = await axios
        .post(
          "caja-chica/aumentar-balance",
          {
            idStore: dataForm.value.idStore,
            idUser: dataForm.value.idUser,
            idTurn: dataForm.value.idTurn,
            amount: parseFloat(dataForm.value.amount),
            concept: dataForm.value.concept,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .catch((error) => errorActions(error));

      if (!response) {
        spinner.value = false;
        return;
      }

      const data = await response.data;
      if (data.msg === true) {
        confirmationOfRecord(`El aumento de balance con referencia <strong>${data.referenceNumber}</strong>`, {
          title: "Registrado",
        });
        dataForm.value.amount = "";
        dataForm.value.concept = "";
        await props.getdata();
        props.activeModal(false);
      } else if (data.msg === "not_found") {
        errorActions("No existe una caja chica activa en esta sucursal");
      } else {
        errorActions("No se pudo aumentar el balance de la caja chica");
      }

      spinner.value = false;
    };

    onMounted(async () => {
      observeElement("#contentIncreasePettyCash");
      dataForm.value.idStore = await idLocalStore();
      dataForm.value.idUser = await idLocalUser();
      dataForm.value.idTurn = await idLocalTurn();
    });

    return {
      dataForm,
      spinner,
      isActive,
      increaseBalance,
    };
  },
};
</script>